export const StepType = {
  GENERAL: { val: 0, name: 'general' },
  MAIN_PROCESS: { val: 1, name: 'mainProcesses' },
  POST_PROCESS: { val: 2, name: 'postProcesses' },
  PRODUCT_REQUIREMENTS: { val: 3, name: 'productRequirements' },
};
